import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "箭头_向右",
  "use": "箭头_向右-usage",
  "viewBox": "0 0 14.02 7.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.02 7.95\" id=\"箭头_向右\"><defs><style>#箭头_向右 .cls-1{fill:#aac2c9;}</style></defs><g id=\"箭头_向右_页面-1\"><g id=\"箭头_向右_威胁防护-任务列表\"><g id=\"箭头_向右_箭头_向右\" data-name=\"箭头 向右\"><polygon id=\"箭头_向右_路径\" class=\"cls-1\" points=\"10.38 3.38 0 3.38 0 4.56 10.38 4.56 7 7.95 14.02 3.97 7.11 0 10.38 3.38\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol